/**
 * Hello Greeting Client — 全局状态（jotai atoms）
 */
import { atom } from 'jotai';
/** Greeting 列表 — 全局共享状态 */
export const greetingsAtom = atom([]);
/** 加载状态 */
export const greetingsLoadingAtom = atom(false);
/** 错误信息 */
export const greetingsErrorAtom = atom(null);
//# sourceMappingURL=state.js.map